import React, { useEffect, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { getRefreshData, postRefreshData } from "./RefreshServices";

const RoutesOnScreen = () => {
  const [firstLocation, setFirstLocation] = useState("N/A");
  const [secondLocation, setSecondLocation] = useState("N/A");

  const locationsNew = [
    {
      routeId: "1",
      origin: {
        name: "Νέο Λιμάνι",
        location: {
          latLng: { latitude: 38.233239, longitude: 21.724597 },
        },
      },
      destination: {
        name: "Γ.Ν. Ο Άγιος Ανδρέας",
        location: {
          latLng: { latitude: 38.238316, longitude: 21.744836 },
        },
      },
      // intermediates: {},
    },
    {
      routeId: "2",
      origin: {
        name: "Πλατεία Γεωργίου",
        location: {
          latLng: { latitude: 38.246463, longitude: 21.73616 },
        },
      },
      destination: {
        name: `Κόμβος Ν.Ε.Ο.\nΑθηνών-Πατρών`,
        location: {
          latLng: { latitude: 38.25584, longitude: 21.746554 },
        },
      },
      // intermediates: {},
    },
  ];

  const locations = {
    first: {
      origin: {
        location: {
          latLng: { latitude: 38.233218, longitude: 21.724722 },
        },
      },
      destination: {
        location: {
          latLng: { latitude: 38.239932, longitude: 21.745375 },
        },
      },
      intermediates: [
        {
          location: {
            latLng: { latitude: 38.233218, longitude: 21.724722 },
          },
        },
        {
          location: {
            latLng: { latitude: 38.231928, longitude: 21.724457 },
          },
        },
        {
          location: {
            latLng: { latitude: 38.229352, longitude: 21.74121 },
          },
        },
        {
          location: {
            latLng: { latitude: 38.23471, longitude: 21.746605 },
          },
        },
        {
          location: {
            latLng: { latitude: 38.237849, longitude: 21.745387 },
          },
        },
        {
          location: {
            latLng: { latitude: 38.239932, longitude: 21.745375 },
          },
        },
      ],
    },
    second: {
      origin: {
        location: {
          latLng: { latitude: 38.246499, longitude: 21.736032 },
        },
      },
      destination: {
        location: {
          latLng: { latitude: 38.255775, longitude: 21.746637 },
        },
      },
      intermediates: null,
    },
  };
  const { search } = useLocation();
  const routeId = new URLSearchParams(search).get("routeId");

  const fetchRouteData = async (loc) => {
    const url = `https://routes.googleapis.com/directions/v2:computeRoutes`;
    var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = new Date(Date.now() - tzoffset).toISOString();

    const body = {
      origin: { location: loc.origin.location },
      destination: { location: loc.destination.location },
      travelMode: "DRIVE",
      departureTime: localISOTime,
      routingPreference: "TRAFFIC_AWARE",
    };

    // if (loc.intermediates) {
    //   body.intermediates = loc.intermediates;
    // }
    // intermediates: loc.intermediates,

    const routeData = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Goog-Api-Key": "AIzaSyDqh-jgSoZRgflwofspuy0kwfOkcmF0Wgo",
        "X-Goog-FieldMask":
          "routes.duration,routes.distanceMeters,routes.polyline.encodedPolyline",
      },
      body: JSON.stringify(body),
    }).then((response) => {
      return response.json();
    });

    return routeData;
  };

  useEffect(() => {
    const fetchRoute = async (loc) => {
      const routeData = await fetchRouteData(loc);
      if (routeData?.routes?.length > 0) {
        const duration =
          Math.round(routeData?.routes[0]?.duration.slice(0, -1) / 60) ?? "12";
        setRefreshData(duration);
        return duration;
      }
      return "N/A";
    };

    const setRefreshData = async (duration) => {
      const refreshed = await postRefreshData(routeId, duration).then(
        (response) => response
      );
    };

    const fetchAllRoutes = () => {
      switch (routeId) {
        case "1":
          fetchRoute(locationsNew[0]).then((locationData) => {
            console.log(`TEST: locationData: ${routeId}`, locationData);

            setFirstLocation(locationData);
          });
          break;
        case "2":
          fetchRoute(locationsNew[1]).then((locationData) => {
            console.log(`TEST: locationData: ${routeId}`, locationData);
            setFirstLocation(locationData);
          });
          break;
      }
    };

    const fetchRefreshData = async () => {
      const data = await getRefreshData(routeId).then((response) => response);

      if (data.counter < 41) {
        fetchAllRoutes();
      } else {
        setRefreshData(data.duration);
        setFirstLocation(data.duration);
      }
    };

    fetchRefreshData();

    const interval = setInterval(fetchRefreshData, 36 * 60 * 1000); // 36 mina

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        width: "160px",
        height: "96px",
        // backgroundColor: "red",
        overflow: "hidden",
        display: "Flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          // fontSize: "11px",
        }}
      >
        <div
          style={{ display: "flex", flexDirection: "column", width: "140px" }}
        >
          <span style={{ fontSize: "12px" }}>Από</span>
          <LargeName>
            {locationsNew.filter((loc) => loc.routeId === routeId)[0]?.origin
              ?.name ?? "Dsa"}
          </LargeName>
          <span style={{ fontSize: "12px" }}>Προς</span>
          {/* <span>Λιμάνι →</span> */}
          <LargeName>
            {
              locationsNew.filter((loc) => loc.routeId === routeId)[0]
                ?.destination?.name
            }
          </LargeName>
        </div>
        <span style={{ width: "10px", fontSize: "20px", fontWeight: "600" }}>
          {firstLocation ?? "N/A"}'
        </span>
      </div>
    </div>
  );
};

export default RoutesOnScreen;

const LargeName = styled.span`
  font-size: 16px;
  white-space: pre;
  padding-bottom: 6px;
`;
